import { Fragment } from 'react';
import { Button, type ButtonProps, cn, IconButton } from '@zep-us/zus';
export const ViewportResponsiveButton = (props: Omit<ButtonProps, 'asChild'>) => {
  const {
    leftSlot,
    rightSlot,
    children,
    className,
    ...rest
  } = props;
  return <Fragment>
      <Button {...rest} leftSlot={leftSlot} rightSlot={rightSlot} variant={'outlined'} intent="neutral" size="sm" className={cn('hidden mobile-lg:flex', className)} data-sentry-element="Button" data-sentry-source-file="ViewportResponsiveButton.tsx">
        {children}
      </Button>
      <IconButton {...rest} variant={'outlined'} intent="neutral" size="sm" className={cn('flex mobile-lg:hidden', className)} data-sentry-element="IconButton" data-sentry-source-file="ViewportResponsiveButton.tsx">
        {leftSlot ?? <></>}
      </IconButton>
    </Fragment>;
};